'use strict';

Object.defineProperty(exports, "__esModule", {
	value: true
});

var _applyConfigs = require('../utils/apply-configs');

var _applyConfigs2 = _interopRequireDefault(_applyConfigs);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

var iconConfig = [{
	name: 'iconClosed',
	inputType: 'icon',
	label: 'Choose icon when slideout is closed',
	default: false
}, {
	name: 'iconClosedSize',
	inputType: 'text',
	label: 'Set size on above icon',
	default: '2em'
}, {
	name: 'iconClosedColor',
	inputType: 'color',
	label: 'Color on closed icon',
	default: '#000'
}, {
	name: 'iconOpen',
	inputType: 'icon',
	label: 'Choose icon when slideout is open',
	default: false
}, {
	name: 'iconOpenSize',
	inputType: 'text',
	label: 'Set size on above icon',
	default: '2em'
}, {
	name: 'iconOpenColor',
	inputType: 'color',
	label: 'Color on open icon',
	default: '#000'
}];

var imageConfig = [{
	name: 'imageClosed',
	inputType: 'media',
	label: 'Image when slideout is closed',
	default: 'example.png'
}, {
	name: 'imageOpen',
	inputType: 'media',
	label: 'Image when slideout is open',
	default: 'example.png'
}];

var textConfig = [{
	name: 'label',
	inputType: 'text',
	label: 'Label',
	default: 'Click me please'
}];

var conditionallyAddConfig = function conditionallyAddConfig(node, conditionStr, configArray) {
	return node && node.props.type === conditionStr ? configArray : [];
};

exports.default = function (node) {
	return {
		type: 'SLIDEOUT_01',
		name: 'Slideout',
		allowedSections: ['header', 'footer', 'main'],
		disallowedChildren: ['POPUP'],
		category: 'Nav',
		props: [{
			name: 'type',
			inputType: 'select',
			label: 'What should trigger the slideout?',
			default: 'icon',
			values: [{
				label: 'Icon',
				value: 'icon'
			}, {
				label: 'Image',
				value: 'image'
			}, {
				label: 'Text',
				value: 'text'
			}]
		}].concat(_toConsumableArray(conditionallyAddConfig(node, 'icon', iconConfig)), _toConsumableArray(conditionallyAddConfig(node, 'image', imageConfig)), _toConsumableArray(conditionallyAddConfig(node, 'text', textConfig)), [{
			name: 'side',
			inputType: 'select',
			label: 'Side to slide out from',
			default: 'Left',
			values: ['Left', 'Right']
		}, {
			name: 'underSticky',
			inputType: 'checkbox',
			label: 'Open under sticky header',
			default: false
		}, {
			name: 'fullWidth',
			label: 'Full size width',
			inputType: 'checkbox',
			default: false
		}, {
			name: 'iconInsideClose',
			inputType: 'icon',
			label: 'Choose close icon (inside slideout)',
			default: false
		}]),
		hiddenProps: (0, _applyConfigs2.default)(['htmlclass']).concat([{
			label: 'Advanced slideout settings',
			props: [{
				name: 'openByDefault',
				inputType: 'checkbox',
				label: 'Open by default',
				default: false
			}, {
				name: 'closeOnClickOutside',
				inputType: 'checkbox',
				label: 'Close on click outisde',
				default: false
			}, {
				name: 'keepOpen',
				inputType: 'checkbox',
				label: 'Keep open',
				default: false
			}, {
				name: 'closeOnUrlChange',
				inputType: 'checkbox',
				label: 'Close slideout on URL change',
				default: true
			}, {
				name: 'identifier',
				inputType: 'text',
				label: 'Slideout identifier',
				default: ''
			}, {
				name: 'onAction',
				inputType: 'select',
				label: 'On Action',
				values: [{
					label: 'None',
					value: 'NONE'
				}, {
					label: 'Shopcart add',
					value: 'SHOPCART_ADD_FULFILLED'
				}, {
					label: 'Favorite add',
					value: 'ARTICLES_FAVORITES_ADD_FULFILLED'
				}],
				default: 'NONE'
			}, {
				name: 'onActionAction',
				label: 'Action',
				inputType: 'select',
				values: [{
					label: 'Open',
					value: 'OPEN'
				}, {
					label: 'Close',
					value: 'CLOSE'
				}],
				default: 'OPEN'
			}, {
				name: 'actionDuration',
				inputType: 'text',
				label: 'Auto ' + (node && node.props.onActionAction === 'OPEN' ? 'close' : 'open') + ' after ' + (node && node.props.actionDuration) + 'ms (0 = infinite)',
				default: '3000'
			}]
		}])
	};
};